import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <Container fluid="md">
      <Link
        to={{ pathname: `${process.env.PUBLIC_URL}/privacy-policy.html` }}
        target="_blank"
      >
        개인정보처리방침
      </Link>
    </Container>
  );
};

export default Footer;
